export default __webpack_public_path__ + "static/media/BeaconLogo.3b9006b5.svg";